export const randomNumber = (min = 0, max = 999999) => {
  return Math.floor(Math.random() * max) + min;
};

/**
 * 
 * @param {number} length 
 * @returns {string}
 */
export const pickSecretAutoCompleteHash = (length) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
